import { useQuery } from '@apollo/client/react';
import { getContactCenterTenants } from '@api/queries/getContactCenterTenants';
import { permissions } from '@app/permissions/permissions';
import useAuth from '@modules/AuthModule/hooks/useAuth';

export const requiredBookingFlowPermission = (tenant: {
  isNextGenJobBookingEnabled: boolean;
  isGranularPermissionsEnabled: boolean;
}) => {
  if (!tenant.isNextGenJobBookingEnabled) {
    return permissions.admin.FEATURE_MANAGEMENT.BOOKING_CONFIG_EDIT;
  }

  return tenant.isGranularPermissionsEnabled
    ? permissions.admin.JOB_BOOKING_SETTINGS.VIEW_EDIT_JOB_BOOKING
    : permissions.admin.JOB_BOOKING_SETTINGS.ACCESS_SETTINGS;
};

export const useBookingFlowAccess = () => {
  const { user } = useAuth();
  const { data, loading, error } = useQuery(getContactCenterTenants);

  const userPermissions = user?.permissions ?? [];
  const isEnabled =
    !loading &&
    !error &&
    !!data?.contactCenterTenants?.some((tenant) =>
      userPermissions.includes(requiredBookingFlowPermission(tenant)),
    );

  return { isEnabled, loading };
};
